import { Subject } from "rxjs";

const subject = new Subject();

const messageService = {
  sendStatus: (message) => subject.next({ message }),
  getStatus: () => subject.asObservable(),
};

export default messageService;
